import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FinancialService {
  payerMapping = {
    Clalit: 'כללית',
    Meuhedet: 'מאוחדת',
    Macabi: 'מכבי',
    Leumit: 'לאומית',
    Private: 'פרטי',
    Menora: 'מנורה',
    Migdal: 'מגדל',
    Phoenix: 'הפניקס',
    Clal: 'כלל',
    Hachshara: 'הכשרה ביטוח',
    Ayalon: 'איילון',
    IDF: 'צה"ל'
  };
  statuses = ['waiting', 'sent', 'paid'];
  combinedExamTypes = ['Gastro-Colonoscopy', 'Gastro-Sigmo'];

  constructor(private http: HttpClient) { }

  get payers(): string[] {
    return Object.keys(this.payerMapping);
  }

  private reportParams(filters: any, extra: any = {}): HttpParams {
    let params = new HttpParams();
    const all = { ...filters, ...extra };
    Object.keys(all).forEach((key) => {
      const value = all[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    });
    return params;
  }

  async getDoctorPrice(UID: number, examTypeID: number, payer: string): Promise<{ found: boolean; price: number | null }> {
    const params = new HttpParams()
      .set('UID', String(UID))
      .set('examTypeID', String(examTypeID))
      .set('payer', payer);
    const data: any = await this.http.get('/api/appointment/payerPrice', { params }).toPromise();
    return { found: !!data?.found, price: data?.price ?? null };
  }

  async getPriceList(UID: number): Promise<any[]> {
    const data: any = await this.http.get(`/api/financial/pricelist/${UID}`).toPromise();
    return data.prices;
  }

  createPrice(price: any): Promise<any> {
    return this.http.post('/api/financial/pricelist', price).toPromise();
  }

  updatePrice(price: any): Promise<any> {
    return this.http.put('/api/financial/pricelist', price).toPromise();
  }

  deletePrice(AutoIndex: number): Promise<any> {
    return this.http.delete('/api/financial/pricelist', { params: { AutoIndex: String(AutoIndex) } }).toPromise();
  }

  getReport(filters: any, limit: number, offset: number): Promise<any> {
    return this.http.get('/api/financial/report', { params: this.reportParams(filters, { limit, offset }) }).toPromise();
  }

  exportReport(filters: any): Promise<Blob> {
    return this.http.get('/api/financial/report/export', {
      params: this.reportParams(filters),
      responseType: 'blob'
    }).toPromise();
  }

  setStatus(body: any): Promise<any> {
    return this.http.put('/api/financial/status', body).toPromise();
  }

  setStatusBulk(body: any): Promise<any> {
    return this.http.put('/api/financial/status/bulk', body).toPromise();
  }
}
